import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { finalize } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { DocumentHandlingService } from 'src/app/shared/document-handling.service';


@Component({
  selector: 'app-search-selection-letters',
  templateUrl: './search-selection-letters.component.html',
  styleUrls: ['./search-selection-letters.component.scss'],
})

export class SearchSelectionLettersComponent implements OnInit {

  error: any = {};
  isLoading: boolean = false;
  tenantId = this.appConstants.endPoints.xTenantId;

  options: any = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 }
  ]

  pageInfo = {
    id: 'searchSelectionModels-pagination',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0,
    disablePagination: false
  };

  constructor(
    private appConstants: AppConstants,
    public translate: TranslateService,
    private service: SharedService,
    private keycloakService: KeycloakService,
    private docService: DocumentHandlingService
  ) {
  }

  userInfo: any = {}
  selectedOption: any
   ngOnInit() {
      this.error = {};
      const user = this.appConstants.userDetails
      this.userInfo = user
      this.selectedOption = this.options[0].value;
      this.pageInfo.itemsPerPage = this.selectedOption;
      this.resetPageInfo();
  }


  resetPageInfo() {
    this.pageInfo.currentPage = 1;
    this.pageInfo.disablePagination = true;
    this.pageInfo.itemsPerPage = this.selectedOption;
    this.pageInfo.totalItems = 0;
    this.searchSelectionModels = [];
  }

  paginationChange(e) {
    this.pageInfo.currentPage = e;
    this.pageInfo.disablePagination = true;
    this.pageInfo.totalItems = 0;
    this.searchSelectionModels = []
    this.getSearchSelectionLetterDocuments();
  }

  searchSelectionModels: any = [];
  searchData: any = ""
  getSearchSelectionLetterDocuments() {
    this.isLoading = true;
    this.searchSelectionModels = [];
    let searchObj = {}
    searchObj['pageSize'] = this.pageInfo.itemsPerPage
    searchObj['pageNumber'] = this.pageInfo.currentPage
    searchObj['isPaging'] = true

    if (this.searchData && this.searchData.length)
      searchObj['modelString'] = this.searchData

    this.service.post(this.appConstants.endPoints.certificatesEndPoint + "critical-components/componenet-selection", {}, searchObj)
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe(res => {
        let searchSelectionModels = res && res.searchResults ? res.searchResults : [];

        this.searchSelectionModels = searchSelectionModels.map(res => { res['isOpen'] = false; return res })
        if (res && res.pagingInfo) {
          this.pageInfo.totalItems = res.pagingInfo.totalRows ? res.pagingInfo.totalRows : this.searchSelectionModels.length;
          this.pageInfo.disablePagination = false;
        }
        else {
          this.pageInfo.totalItems = this.searchSelectionModels.length;
          this.pageInfo.disablePagination = true;
          this.searchSelectionModels = []
        }
      })
  }


  goDownload(doc) {
    this.docService.goDownload(doc)
  }



  setPageSize(value) {
    this.pageInfo.currentPage = 1;
    this.pageInfo.itemsPerPage = value;
    this.pageInfo.disablePagination = true;
    this.searchSelectionModels = [];
    this.getSearchSelectionLetterDocuments();
  }


}
